import { MicroFrontEnd, useEntitlements } from 'properties-ui-common'
import { useParams } from 'react-router-dom'
import { mfeNavUrls } from '../utility/url'
import { Grid } from '@enterprise-ui/canvas-ui-react'
import { apiConfig } from '../../../apiConfig'
import { TgtLogger } from '@measurement/opentelemetry-web'

export const ItemDetailsDashboard = () => {
  const { id } = useParams<string>()
  const { entitlements } = useEntitlements()
  const isPolNri = entitlements.nri.pol
  return (
    <Grid.Container>
      <Grid.Item xs={7}>
        <MicroFrontEnd
          name="IndirectItemDetailsNri"
          src={apiConfig.microFrontEnds.IndirectItemDetailsNri}
          props={{
            mfeNavUrls,
            tcinKey: id,
          }}
          mode={MicroFrontEnd.Mode.Read}
          useErrorBoundary
          logger={TgtLogger}
        />
      </Grid.Item>
      <Grid.Item xs={5}>
        <Grid.Container>
          <Grid.Item xs={12}>
            <MicroFrontEnd
              name="IndirectItemDocuments"
              src={apiConfig.microFrontEnds.IndirectItemDocuments}
              props={{
                mfeNavUrls,
                tcinKey: id,
              }}
              useErrorBoundary
              logger={TgtLogger}
            />
          </Grid.Item>
          <Grid.Item xs={12}>
            <MicroFrontEnd
              name="IndirectItemRelatedItems"
              src={apiConfig.microFrontEnds.IndirectItemRelatedItems}
              props={{
                mfeNavUrls,
                tcinKey: id,
              }}
              useErrorBoundary
              logger={TgtLogger}
            />
          </Grid.Item>
        </Grid.Container>
      </Grid.Item>
      <Grid.Item xs={12}>
        {(entitlements?.sourcing?.read || entitlements?.ttsAdmin?.create) &&
          !isPolNri && (
            <MicroFrontEnd
              name="HznItemDetails"
              src={apiConfig?.microFrontEnds.HznItemDetails}
              props={{
                tcinKey: id,
              }}
              useErrorBoundary
              logger={TgtLogger}
            />
          )}
      </Grid.Item>
      <Grid.Item xs={12}>
        {entitlements?.catItem?.read && !isPolNri && (
          <MicroFrontEnd
            name="HznItemCatalogs"
            src={apiConfig?.microFrontEnds.HznItemCatalogs}
            useErrorBoundary
            logger={TgtLogger}
          />
        )}
      </Grid.Item>
    </Grid.Container>
  )
}

export default ItemDetailsDashboard
